<div class="organization-profile-logo">
    <img
        [ngStyle]="{ 'width.px': width, 'height.px': width/2 }"
        src="{{image}}"
        width="80"
        height="40"
        border="0"
        class=""
    />
    <em></em>
</div>